import LabelMap from '../../types/label-map/LabelMap';
import __ from '../../i18n';


const PRESET_TYPE_CONDITION_LEVEL = 'CONDITION_LEVEL';
const PRESET_TYPE_BRAND = 'BRAND';

export default new LabelMap([
    [PRESET_TYPE_CONDITION_LEVEL, __('Condition level')],
    [PRESET_TYPE_BRAND, __('Brand')],
]);

export {
    PRESET_TYPE_CONDITION_LEVEL,
    PRESET_TYPE_BRAND,
}
